const SAMPLE_WELL = {
  coord: null,
  cycle: null,
  id: null,
  sample: null,
  status: null,
  subject: null,
  type: null,
};

export const DND_ITEM_TYPE_WELL = 'WELL';

export const coordToIndex = (coord = '') => `UDI-${coord.toUpperCase()}`;
export const indexToCoord = (index = '') => index.replace(/UDI-/ig, '').toUpperCase();

export default class Well {
  constructor(obj = {}) {
    const clone = JSON.parse(JSON.stringify(obj));
    this.well = {
      ...SAMPLE_WELL,
      ...clone,
      type: DND_ITEM_TYPE_WELL,
    };

    // trim leaf
    if (this.well.subject) delete(this.well.subject.cycles);
    if (this.well.cycle) delete(this.well.cycle.samples);
  }

  get(field = null, fallback = null) {
    if (field) {
      const fields = field.split('.');
      return fields.reduce((obj, field) => (obj || {})[field], this.well)
        || fallback;
    }
    return this.well;
  }

  getLabel() {
    const { cycle, sample } = this.well;
    return this.hasData()
      ? `${this.getSubjectName()} - ${cycle['external_id']} - ${sample['external_id']}`
      : this.hasSampleData()
        ? sample['external_id']
        : '';
  }

  getSubjectName() {
    const { subject } = this.well;
    return (subject.firstname || subject.lastname)
      ? `${subject.firstname} ${subject.lastname}`
      : subject['external_id'];
  }

  hasData() {
    const { cycle, sample, subject } = this.well;
    return subject && subject.id && cycle && cycle.id && sample && sample.id;
  }

  hasSampleData() {
    const { sample } = this.well;
    return sample && sample.id;
  }

  match(well) {
    const { cycle, sample, subject } = this.well;
    return well.subject && well.cycle
      && subject.id === well.subject.id
      && cycle.id === well.cycle.id
      && sample.id === well.sample.id;
  }

  set(input = {}) {
    this.well = { ...this.well, ...input };
    return this;
  }
}
